import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ru from './locales/ru.json';

// Detect browser language and set to Arabic if detected, otherwise English
const detectLanguage = () => {
  const browserLanguage = navigator.language || navigator.languages?.[0] || 'en';
  return browserLanguage.startsWith('ar') ? 'ar' : 'en';
};

const detectedLanguage = detectLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      ar: {
        translation: ar
      },
      es: {
        translation: es
      },
      fr: {
        translation: fr
      },
      ru: {
        translation: ru
      }
    },
    lng: detectedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Set document direction and language on initialization
document.documentElement.dir = detectedLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = detectedLanguage;

export default i18n;